import { z } from "zod";

export type BoardLayout = "list" | "board";

/** A stored layout that no longer parses falls back to List alone. */
export const boardLayoutSchema = z.enum(["list", "board"]).catch("list");

/** A stored list that no longer parses falls back to empty alone. */
const collapsedSchema = z.object({
    collapsedColumnIds: z.array(z.string()).catch([]),
    collapsedLaneIds: z.array(z.string()).catch([]),
});

/** The columns and lanes a user collapsed: personal, never part of a view. */
export type BoardCollapsed = z.infer<typeof collapsedSchema>;

const DEFAULT_COLLAPSED: BoardCollapsed = {
    collapsedColumnIds: [],
    collapsedLaneIds: [],
};

/** What a List/Board page remembers per user, with the page's own collapse state. */
export interface BoardLayoutCacheOf<TCollapsed> {
    layout: BoardLayout;
    board: TCollapsed;
}

/** Keys a page no longer stores here are dropped. */
export const boardLayoutCacheSchema = z.object({
    layout: boardLayoutSchema,
    board: collapsedSchema.catch(DEFAULT_COLLAPSED),
});

/** What a List/Board page remembers per user: the layout and the collapsed columns and lanes. */
export type BoardLayoutCache = BoardLayoutCacheOf<BoardCollapsed>;

export const DEFAULT_BOARD_LAYOUT_CACHE: BoardLayoutCache = {
    layout: "list",
    board: DEFAULT_COLLAPSED,
};
